import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {Master} from '../../../../../admin/models/master.interface';
import {FormBuilder, FormControl} from '@angular/forms';
import {ChartsSearchInterface} from '../../../../models/charts-search.interface';
import {MatSelectChange} from '@angular/material/select';
import {setFormValuesFromQueryParams} from '../../../../utils/filters-utils';
import {ActivatedRoute} from '@angular/router';
import {MatOption} from '@angular/material/core';

@Component({
  selector: 'app-return-trend-by-country-filter',
  templateUrl: './return-trend-by-country-filter.component.html',
  styleUrls: ['./return-trend-by-country-filter.component.scss']
})
export class ReturnTrendByCountryFilterComponent implements OnInit, OnChanges {

  @ViewChild('allSelected') private allSelected!: MatOption;

  @Input()
  years!: number[];
  @Input()
  categories!: Master[];

  searchForm = this.formBuilder.group({
    year: [''],
    categories: [''],
    detailLevel: [],
    b2bB2c: [],
    member: [],
    displayUnits: ['ABSOLUTE'],
  });

  get yearControl(): FormControl {
    return this.searchForm.get('year') as FormControl;
  }
  get categoriesControl(): FormControl {
    return this.searchForm.get('categories') as FormControl;
  }
  get detailLevelControl(): FormControl {
    return this.searchForm.get('detailLevel') as FormControl;
  }
  get b2bB2cControl(): FormControl {
    return this.searchForm.get('b2bB2c') as FormControl;
  }
  get memberControl(): FormControl {
    return this.searchForm.get('member') as FormControl;
  }

  @Output()
  search: EventEmitter<ChartsSearchInterface> = new EventEmitter<ChartsSearchInterface>();
  @Output()
  loadCategories: EventEmitter<string> = new EventEmitter<string>();

  constructor(private formBuilder: FormBuilder, private activatedRoute: ActivatedRoute) { }

  ngOnInit(): void {
    this.yearControl.setValue(this.years[2]);
    setFormValuesFromQueryParams(this.searchForm, this.activatedRoute);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.categories?.length) {
      if (!this.categoriesControl.value || this.categoriesControl.value.length === this.categories.length) {
        if (this.allSelected) {
          this.allSelected.select();
        }
        this.categoriesControl
          .patchValue([...this.categories.map(item => item.id.toString()), 0]);
      }
    }
  }

  handleSubmit(): void {
    const search: ChartsSearchInterface = {
      startYear: this.yearControl.value,
      categories: this.categoriesControl.value,
      detailLevel: this.detailLevelControl.value,
      b2bB2c: this.b2bB2cControl.value,
      member: this.memberControl.value,
      displayUnits: this.searchForm.controls.displayUnits.value,
    };
    this.search.emit(search);
    if (this.categoriesControl.value.length === this.categories.length) {
      this.allSelected.select();
    }
  }

  clean(): void {
    this.yearControl.setValue(this.years[0]);
    this.categoriesControl.setValue('');
    this.detailLevelControl.setValue(null);
    this.b2bB2cControl.setValue(null);
    this.memberControl.reset();
    this.searchForm.controls.displayUnits.setValue('ABSOLUTE');
    this.search.emit({startYear: this.years[0], displayUnits: 'ABSOLUTE'});
  }

  getCategories(event: MatSelectChange): void {
    if (event?.value) {
      this.loadCategories.emit(event.value);
    }
  }

  togglePerOne(): void {
    if (this.allSelected.selected) {
      this.allSelected.deselect();
      return;
    }
    if (this.categoriesControl.value.length === this.categories.length) {
      this.allSelected.select();
    }
  }

  toggleAllSelection(): void {
    if (this.allSelected.selected) {
      this.categoriesControl
        .patchValue([...this.categories.map(item => item.id.toString()), 0]);
    } else {
      this.categoriesControl.patchValue([]);
    }
  }

}
